module.exports = __webpack_public_path__ + "static/office-3-61237819df8d8df9c84625f18f3191bd.webp";